<template>
  <div>
    <b-server-autocomplete
      v-model="data.executorId"
      :error-messages="getErrorMessages(v$.executorId)"
      :url="urlAllUsers()"
      hide-details
      item-title="name"
      item-value="id"
      label="Новий виконавець"
      placeholder="Введіть мін. 3 символи"
      @blur="v$.executorId.$touch()" />
  </div>
</template>

<script>
import { reactive } from 'vue'
import { getErrorMessages } from 'best-modules/utils'
import { required, useVuelidate } from '@/plugins'
import { urlAllUsers } from '@/utils/urls'
import { setSnackbar } from 'best-modules/plugins'
import { BServerAutocomplete } from 'best-modules/components'
import { taskDelegate } from '@/requests/task'

export default {
  name: 'TaskDelegation',
  components: {
    BServerAutocomplete,
  },
  props: {
    dialog: {
      type: Object,
      required: true,
    },
  },
  methods: { urlAllUsers, getErrorMessages },
  setup(props) {
    const data = reactive({
      executorId: null,
    })

    const v$ = useVuelidate(
      {
        executorId: { required },
      },
      data
    )

    const submit = () => {
      return taskDelegate(props.dialog.dialogData.taskId, data.executorId).then(
        res => {
          setSnackbar({ text: 'Завдання делеговано', color: 'success' })
          return res
        }
      )
    }

    return {
      v$,
      data,
      submit,
    }
  },
}
</script>

<style lang="scss" scoped></style>
